/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  emailChangedHeading: {
    id: "ChangeEmailSucceededPageComponent.emailChangedHeading",
    defaultMessage: "Email change request successful",
  },
  emailChangedText: {
    id: "ChangeEmailSucceededPageComponent.emailChangedText",
    defaultMessage: "You will recieve an e-mail with an activation link. Please click it to activate your new email.",
  },
  emailChangedButton: {
    id: "ChangeEmailSucceededPageComponent.emailChangedButton",
    defaultMessage: "Go back to login",
  },
});

export default MESSAGES;